angular
.module('vppApp')
.service('ProgramStopGateService', ProgramStopGateService);
ProgramStopGateService.$inject = ['$http', '$q'];
function ProgramStopGateService($http, $q) {
  var programStopGateService = {};

  programStopGateService.generateWhitelistedProgramDetailsList = function (programDetails) {
    var deferred = $q.defer();


    $http.get('./content/json/programInfo/whitelist.json')
      .then(function(response) {
        if(programDetails){
          var whitelistedCodes = response.data.programCodes;
          var arr = [];
          var detailsLength = programDetails.length;

          //loop through programDetails, add to arr if program code is in whitelistedCodes
          for(var i = 0; i < detailsLength; i++) {
            if(whitelistedCodes.indexOf(programDetails[i].code) > -1) {
              arr.push(programDetails[i]);
            }
          }
        }

        deferred.resolve(arr);
      },
      function(response) {
        console.log('programStopGateService.getJson error: ', response);
        deferred.reject(response);
      });
    return deferred.promise;
  };

  return programStopGateService;
}
